import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
// v2.71.77 — Install global error/rejection guards BEFORE React mounts so
// errors thrown during initial render are caught + classified (chunk-load,
// expected-noise, real bug). Side-effect-only import.
import { installGlobalErrorGuards } from "@/shared/utils/globalErrorGuards";

installGlobalErrorGuards();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
